// Lazy banner stack — none of these are above-the-fold for LCP.
// Splitting them into a separate chunk shortens the initial JS critical path.
import { Suspense, lazy } from "react";
import { TopBanner } from "../banners";

const DailyBlogBanner = lazy(() => import("../banners/DailyBlogBanner"));
const IPLPromoBanner = lazy(() => import("../banners/IPLPromoBanner"));
const RotatingGeoBanner = lazy(() => import("../banners/RotatingGeoBanner"));

// One small skeleton row so layout doesn't shift.

const BannerStack = () => (
  <div>
    {/* Top featured carousel stays eager — it's the first thing under nav and visible immediately */}
    <TopBanner />
    <Suspense fallback={null}>
      <DailyBlogBanner />
    </Suspense>
    <Suspense fallback={null}>
      <IPLPromoBanner />
    </Suspense>
    <Suspense fallback={null}>
      <RotatingGeoBanner />
    </Suspense>
  </div>
);

export default BannerStack;
